export enum DeclineReasonListInclusion {
    All = 0,
    MatchHistoryDeclines = 1,
    PreselectDeclines = 2
}